import React, { FC } from 'react';
import { GetStaticProps } from 'next';
import Head from 'next/head';

import UXCoreLayout from '@layouts/UXCoreLayout';

import Spinner from '@components/Spinner';

import { getBullyingDefence } from '@api/bullyingDefence';

interface UXCoreProps {
  description?: string;
  bullyingDefence: any;
}

const Bullying: FC<UXCoreProps> = ({
  description,
  bullyingDefence,
}) => {
  
  return (
    <>
      {/*<SeoGenerator strapiSEO={seoData} />*/}
      <Head>
        <link
          rel="preload"
          as="image"
          href="https://strapi.darkhacks.xyz/uploads/even_724ed7c9e7.png"
        />
        <link
          rel="preload"
          as="image"
          href="https://strapi.darkhacks.xyz/uploads/odd_6e4a6e18be.png"
        />
      </Head>
      <UXCoreLayout
        strapiBiases={bullyingDefence.data}
        description={description}
      />

      <Spinner />
    </>
  );
};

export default Bullying;

export const getStaticProps: GetStaticProps = async ({  }) => {
  const bullyingDefence = await getBullyingDefence();
  
  return {
    props: {
      bullyingDefence,
    },
    revalidate: 5,
  };
};
